<template>
<div class="supply-monitor">
    <div class="box">
        <div class="box-content">
            <!-- 全部用 font-awesome-icon 组件，数组格式 -->
            <div class="box-item">
                <div class="box-item-icon">
                    <svg-icon name="total-water" class-name="icon" />
                </div>
                <div class="box-item-content">
                    <div class="box-item-content-body">
                        <span>{{ totalWater }}</span> m³
                    </div>
                    <div class="box-item-content-title">{{ $t('年供水流量') }}</div>
                </div>
            </div>
            <div class="box-item">
                <div class="box-item-icon">
                    <svg-icon name="droplet" class-name="icon" />
                </div>
                <div class="box-item-content">
                    <div class="box-item-content-body">
                        <span>{{ todayWater }}</span> m³
                    </div>
                    <div class="box-item-content-title">{{ $t('今日供水量') }}</div>
                </div>
            </div>
            <div class="box-item">
                <div class="box-item-icon">
                    <svg-icon name="gauge-high" class-name="icon" />
                </div>
                <div class="box-item-content">
                    <div class="box-item-content-body">
                        <span>{{ pressure }}</span> MPa
                    </div>
                    <div class="box-item-content-title">{{ $t('出水压力') }}</div>
                </div>
            </div>
            <div class="box-item">
                <div class="box-item-icon">
                    <svg-icon name="water" class-name="icon" />
                </div>
                <div class="box-item-content">
                    <div class="box-item-content-body">
                        <span>{{ currentWater }}</span> m³/h
                    </div>
                    <div class="box-item-content-title">{{ $t('瞬时流速') }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import "./icon/total-water.svg"; // 确保引入 SVG 图
import "./icon/droplet.svg"; // 确保引入 SVG 图
import "./icon/gauge-high.svg"; // 确保引入 SVG 图
import "./icon/water.svg"; // 确保引入 SVG 图
export default {
    name: 'SupplyMonitor',
    props: {
        onRefresh: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            totalWater: 23456,
            todayWater: 66,
            currentWater: 123,
            pressure: 2.34
        }
    },
    methods: {
        refreshData() {
            // 模拟数据刷新
            this.totalWater = Math.floor(this.totalWater * (1 + Math.random() * 0.01));
            this.todayWater = Math.floor(this.todayWater * (1 + Math.random() * 0.05));
            this.currentWater = (this.currentWater * (1 + (Math.random() - 0.5) * 0.1)).toFixed(1);
            this.pressure = (this.pressure * (1 + (Math.random() - 0.5) * 0.02)).toFixed(2);
        },
        adjustSize() {
            // 获取容器高度
            const container = this.$el.closest('.container-body');
            if (container) {
                this.$el.style.height = `${container.clientHeight}px`;
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.adjustSize);
        this.$nextTick(() => {
            this.adjustSize();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.adjustSize);
    }
}
</script>

<style lang="less" scoped>
.supply-monitor {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0.5rem;
}

.box {
    height: 100%;
    display: flex;
    flex-direction: column;

    .box-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.5rem;
        padding: 0.25rem;
        box-sizing: border-box;
        overflow: hidden;
    }

    .box-item {
        color: #fff;
        display: flex;
        /* 横向布局 */
        align-items: center;
        /* 垂直居中对齐 */
        width: calc(50% - 0.25rem);
        height: calc(50% - 0.25rem);
        border: 1px solid rgba(0, 150, 255, 0.3);
        border-radius: 4px;
        background: rgba(202, 202, 202, 0.1);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.5rem;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg,
                    rgba(0, 150, 255, 0.05) 0%,
                    rgba(0, 150, 255, 0) 50%);
            pointer-events: none;
        }

        &:hover {
            box-shadow: 0 0 15px rgba(0, 150, 255, 0.3);
            border-color: rgba(0, 150, 255, 0.6);
            transform: translateY(-2px);
        }

        .box-item-icon {
            font-size: clamp(1.5rem, 10vw, 2.5rem);
            /* 放大图标 */
            color: #0096ff;
            margin-right: 0.75rem;
            /* 图标与内容间距 */
            width: clamp(2.5rem, 15vw, 3.5rem);
            height: clamp(2.5rem, 15vw, 3.5rem);
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 150, 255, 0.1);
            border: 1px solid rgba(0, 150, 255, 0.3);
            border-radius: 50%;
            flex-shrink: 0;
            position: relative;
            /* 防止图标被压缩 */

            .icon {
                width: 100%;
                height: 100%;
                /* 核心：蓝色辉光，模糊半径 10px，可按需调 */
                filter: drop-shadow(0 0 10px rgba(0, 191, 255, 0.8));
                fill: #fff;
                /* SVG 本身颜色，按需改 */
            }
        }

        .box-item-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex-grow: 1;
            /* 占满剩余空间 */
        }

        .box-item-content-body {
            font-size: clamp(0.875rem, 4vw, 1rem);
            margin-bottom: 0.25rem;

            span {
                font-family: 'ds-digital-bold';
                font-size: clamp(1.25rem, 8vw, 1.75rem);
                color: #40a9ff;
                text-shadow: 0 0 10px rgba(0, 150, 255, 0.5);
            }
        }

        .box-item-content-title {
            font-size: clamp(0.875rem, 4vw, 1rem);
            color: rgba(255, 255, 255, 0.8);
            letter-spacing: 0.5px;
        }
    }
}

// 响应式调整
@media (max-width: 768px) {
    .box-item {
        .box-item-icon {
            font-size: clamp(1.25rem, 8vw, 2rem);
            width: clamp(2rem, 12vw, 3rem);
            height: clamp(2rem, 12vw, 3rem);
            margin-right: 0.5rem;
        }

        .box-item-content-body span {
            font-size: clamp(1rem, 6vw, 1.5rem);
        }
    }
}

@media (max-width: 480px) {
    .box-content {
        flex-direction: column;
    }

    .box-item {
        width: 100%;
        height: auto;
        min-height: 80px;
    }
}
</style>
